import { useQuery, NetworkStatus } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { gql } from '@/__generated__';

const AdminUsersSearchQuery = gql(`
  query AdminUsersSearchQuery($input: UsersListInput!) {
    getUsers(input: $input) {
      items {
        ...UserCardFragment
      }
      nextToken
    }
  }
`);

export const useAdminUsersSearch = () => {
  const toast = useToast();
  const [value, setValue] = useState('');
  const [debouncedValue] = useDebounce(value, 300);

  const { data, networkStatus } = useQuery(AdminUsersSearchQuery, {
    variables: {
      input: {
        searchString: debouncedValue || undefined,
        limit: 10,
        nextToken: null,
      },
    },
    skip: !debouncedValue,
    onError: () => {
      toast.error({
        title: 'Failed to search users',
      });
    },
    notifyOnNetworkStatusChange: true,
  });

  return {
    users: data?.getUsers.items,
    value,
    onValueChange: setValue,
    isLoading:
      networkStatus === NetworkStatus.loading ||
      networkStatus === NetworkStatus.setVariables,
  };
};
